// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"22":"datenschutz","889":"datenschutz_ed"}[chunkId] + "." + {"22":"c6aac0c9","889":"a2121c64"}[chunkId] + ".js";
};